<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/lYQsFJ/tc-custom/9781625849458.jpg?1703852200214" alt="This image is the cover for the book Attack of the HMS Nimrod"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Attack of the HMS Nimrod
      </h1>
      <p class="bookDescription body article font2">
        <p>On the morning of June 13, 1814, the British warship HMS" Nimrod" attacked the town of Wareham, Massachusetts. As a center for shipbuilding and iron, Wareham was a perfect target for the British fleet. When the lead barge deceptively appeared with a white flag at its bow, Wareham never suspected anything but a truce and was ill prepared for the attack. A raiding party with six barges and two hundred men burned the town's cotton mill, destroyed its vessels and took its citizens as hostages. When "Nimrod" tried to flee the shores, it ran aground and had to throw its cannons and guns overboard in order to lighten its load and sail away. Wareham was left smoldering in its wake. Follow authors J. North Conway and Jesse Dubuc as they trace the attack from the initial spotting of the British fleet to the discovery of the lost "Nimrod "cannons.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        J. North Conway, Jesse Dubuc
      </h2>
      
      <p class="authorDescription body article">J. North Conway is the author of a dozen nonfiction books including The Cape Cod Canal: Breaking Through the Bared and Bended Arm, " published by History Press in 2008. He teaches at the University of Massachusetts, Dartmouth and Bridgewater State University. Jesse Dubuc was born and raised in southeastern Massachusetts, and works as a historical conservator at Battleship Cove in Fall River, Massachusetts. This is his first nonfiction work. Wareham resident Katy Whittingham is a poet and educator. She teaches English at the University of Massachusetts, Dartmouth and Bridgewater State University."</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The History Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?9f8581e6